import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { Login } from "./features/auth/pages/Login";
import { Dashboard } from "./features/dashboard/pages/Dashboard";
import { ProtectedRoute } from "./shared/components/ProtectedRoute";
import { ProtectedLayout } from "./shared/components/ProtectedLayout";
import { useAuthStore } from "./features/auth/stores/authStore";
import { ForgotPassword } from "./features/auth/pages/ForgotPassword";
import { ResetPassword } from "./features/auth/pages/ResetPassword";
import { AcceptMembershipInvitation } from "./features/auth/pages/AcceptMembershipInvitation";
import { UserManagement } from "./features/admin/pages/UserManagement";
import { DriversManagementPage } from "./features/dispatch/pages/DriversManagementPage";
import { TransportRatesPage } from "./features/dispatch/pages/TransportRatesPage";
import { VehiclesManagementPage } from "./features/dispatch/pages/VehiclesManagementPage";
import { RouteTemplatesPage } from "./features/dispatch/pages/RouteTemplatesPage";
import { TripsPage } from "./features/dispatch/pages/TripsPage";
import { DeliveryPlansPage } from "./features/dispatch/pages/DeliveryPlansPage";
import { TrayPickupsPage } from "./features/dispatch/pages/TrayPickupsPage";
import { CustomerManagement } from "./features/customers/pages/CustomerManagement";
import { CustomerDetailPage } from "./features/customers/pages/CustomerDetailPage";
import { WalletApprovalsPage } from "./features/wallets/pages/WalletApprovalsPage";
import { PointsConfigListPage } from "./features/loyalty/pages/PointsConfigListPage";
import { PointsConfigApprovalsPage } from "./features/loyalty/pages/PointsConfigApprovalsPage";
import { PointsApprovalsPage } from "./features/loyalty/pages/PointsApprovalsPage";
import { RoleManagement } from "./features/admin/pages/RoleManagement";
import { SystemSettingsPage } from "./features/admin/pages/SystemSettingsPage";
import { AuditLogsPage } from "./features/admin/pages/AuditLogsPage";
import { CustomersGroupManagement } from "./features/customerGroups/pages/CustomerGroupManagement";
import { SupplierManagement } from "./features/inventory/pages/SupplierManagement";
import { InputManagement } from "./features/inventory/pages/InputsManagement";
import { BatcheAlertsPage } from "./features/inventory/pages/BatchAlertsPage";
import { GreenhouseManagement } from "./features/farms/pages/GreenhouseManagement";
import { GreenhouseLayoutPage } from "./features/farms/pages/GreenhouseLayoutPage";
import { GreenhouseStockTakePage } from "./features/farms/pages/GreenhouseStockTakePage";
import StockManagementPage from "./features/inventory/pages/StockManagementPage";
import { InputTypeManagement } from "./features/inventory/pages/InputTypeManagement";
import { StockReceiptPage } from "./features/inventory/pages/StockReceiptPage";
import { RequisitionPage } from "./features/inventory/pages/RequisitionPage";
import { RequisitionsPage } from "./features/inventory/pages/RequisitionsPage";
import { ReturnApprovalsPage } from "./features/inventory/pages/ReturnApprovalsPage";
import { MyReturnsPage } from "./features/inventory/pages/MyReturnsPage";
import { StoreInventoryPage } from "./features/inventory/pages/StoreInventoryPage";
import { VarietyPricingManagement } from "./features/production/pages/VarietyPricingManagement";
import { OrderManagement } from "./features/production/pages/OrderManagement";
import { WalkInSalePage } from "./features/production/pages/WalkInSalePage";
import { CropsManagement } from "./features/production/pages/CropsManagement";
import { SowingManagementPage } from "./features/production/pages/SowingManagementPage";
import { RecordGerminationPage } from "./features/production/pages/RecordGerminationPage";
import { RecordSowingPage } from "./features/production/pages/RecordSowingPage";
import { RecordDispatchPage } from "./features/production/pages/RecordDispatchPage";
import { RecordGrowthPage } from "./features/production/pages/RecordGrowthPage";
import { ReportsPage } from "./features/reports/pages/ReportsPage";
import { SowingBreakdownReportPage } from "./features/reports/pages/SowingBreakdownReportPage";
import { PaymentsManagement } from "./features/payments/pages/PaymentsManagement";
import { PaymentMethodsPage } from "./features/paymentMethods/pages/PaymentMethodsPage";
import { InvoicingManagement } from "./features/invoicing/pages/InvoicingManagement";
import { SupplierInvoiceDetailPage } from "./features/invoicing/pages/SupplierInvoiceDetailPage";
import { SalesInvoiceDetailPage } from "./features/invoicing/pages/SalesInvoiceDetailPage";
import { VoidRequestsPage } from "./features/invoicing/pages/VoidRequestsPage";
import { CreditNotesPage } from "./features/invoicing/pages/CreditNotesPage";
import { CallCenterPage } from "./features/callCenter/pages/CallCenterPage";
import { PendingAcceptancePage } from "./features/production/pages/PendingAcceptancePage";
import { AmendmentApprovalPage } from "./features/production/pages/AmendmentApprovalPage";
import { AmendmentHistoryPage } from "./features/production/pages/AmendmentHistoryPage";
import { OrderAmendmentApprovalPage } from "./features/production/pages/OrderAmendmentApprovalPage";
import { OrderAmendmentHistoryPage } from "./features/production/pages/OrderAmendmentHistoryPage";
import { SowingCalendarPlannerPage } from "./features/production/pages/SowingCalendarPlannerPage";
import { ReadyForGrowingPage } from "./features/production/pages/ReadyForGrowingPage";
import { MaterialUsagePage } from "./features/production/pages/MaterialUsagePage";
import { GreenhouseStockEntriesPage } from "./features/production/pages/GreenhouseStockEntriesPage";
import { ExposPage } from "./features/expos/pages/ExposPage";
import { ExpoDetailPage } from "./features/expos/pages/ExpoDetailPage";
import { ExpoFormPage } from "./features/expos/pages/ExpoFormPage";
import { ExpoTransferFormPage } from "./features/expos/pages/ExpoTransferFormPage";
import { ExpoTransferDetailPage } from "./features/expos/pages/ExpoTransferDetailPage";
import { ExpoSalePage } from "./features/expos/pages/ExpoSalePage";
import { BulkImportStockPage } from "./features/production/pages/BulkImportStockPage";
import { ReservedOrdersPage } from "./features/production/pages/ReservedOrdersPage";
import { GerminationChambersPage } from "./features/production/pages/GerminationChambersPage";
import { CreateSowingInstructionPage } from "./features/production/pages/CreateSowingInstructionPage";
import { DispatchManagement } from "./features/dispatch/pages/DispatchManagement";
import { DispatchDetailPage } from "./features/dispatch/pages/DispatchDetailPage";
import { CompensationNotesPage } from "./features/dispatch/pages/CompensationNotesPage";
import { ReconciliationPage } from "./features/dispatch/pages/ReconciliationPage";
import { ChartOfAccountsPage } from "./features/accounting/pages/ChartOfAccountsPage";
import { JournalEntriesPage } from "./features/accounting/pages/JournalEntriesPage";
import { FinancialReportsPage } from "./features/accounting/pages/FinancialReportsPage";
import { BankAccountsPage } from "./features/accounting/pages/BankAccountsPage";
import { BudgetsPage } from "./features/accounting/pages/BudgetsPage";
import { CostCentresPage } from "./features/accounting/pages/CostCentresPage";
import { CompaniesPage } from "./features/accounting/pages/CompaniesPage";
import { FinancialYearsPage } from "./features/accounting/pages/FinancialYearsPage";
import { FinancialYearDetailPage } from "./features/accounting/pages/FinancialYearDetailPage";
import { FinancialYearComparePage } from "./features/accounting/pages/FinancialYearComparePage";
import { OvergrownDiscardPage } from "./features/production/pages/OvergrownDiscardPage";
import { ProductionDiscardApprovalsPage } from "./features/production/pages/ProductionDiscardApprovalsPage";
import { AgroforestryReceiveStockPage } from "./features/agroforestry/pages/AgroforestryReceiveStockPage";
import { AgroforestryReceiptApprovalsPage } from "./features/agroforestry/pages/AgroforestryReceiptApprovalsPage";
import { AgroforestryStockPage } from "./features/agroforestry/pages/AgroforestryStockPage";
import { AgroforestryDiscardApprovalsPage } from "./features/agroforestry/pages/AgroforestryDiscardApprovalsPage";
import { ReserveReleaseApprovalsPage } from "./features/production/pages/ReserveReleaseApprovalsPage";
import { GreenhouseTransfersPage } from "./features/production/pages/GreenhouseTransfersPage";
import { GreenhouseTransferDetailPage } from "./features/production/pages/GreenhouseTransferDetailPage";
import { GreenhouseTransferApprovalsPage } from "./features/production/pages/GreenhouseTransferApprovalsPage";
import { InputDiscardApprovalsPage } from "./features/inventory/pages/InputDiscardApprovalsPage";
import { StockReceiptApprovalsPage } from "./features/inventory/pages/StockReceiptApprovalsPage";
import { SupplierApprovalsPage } from "./features/inventory/pages/SupplierApprovalsPage";
import { CustomerSeedApprovalsPage } from "./features/production/pages/CustomerSeedApprovalsPage";
import { SetupApprovalsPage } from "./features/production/pages/SetupApprovalsPage";
import { MySubmissionsPage } from "./features/production/pages/MySubmissionsPage";
import { PaymentThresholdOverridesPage } from "./features/production/pages/PaymentThresholdOverridesPage";
import SalesReviewQueuePage from "./features/production/pages/SalesReviewQueuePage";
import ForecastRequestsPage from "./features/production/pages/ForecastRequestsPage";
import FieldOversightPage from "./features/production/pages/FieldOversightPage";
import { AccountPage } from "./features/auth/pages/AccountPage";
import { NotificationsPage } from "./features/notifications/pages/NotificationsPage";
import { NotificationCenterPage } from "./features/notifications/pages/NotificationCenterPage";
import SalesSummaryPage from "./features/sales/pages/SalesSummaryPage";
import { DiscountApprovalsPage } from "./features/discounts/pages/DiscountApprovalsPage";
import { DirectorsReportsPage } from "./features/directorsReports/pages/DirectorsReportsPage";
import { ForbiddenModal } from "./shared/components/feedback/ForbiddenModal";
import { ReceiptPrintModal } from "./features/payments/components/ReceiptPrintModal";
import { MaintenanceBanner } from "./shared/components/feedback/MaintenanceBanner";
import { useMaintenancePoll } from "./shared/hooks/useMaintenancePoll";

import { UnauthorizedPage } from "./shared/pages/UnauthorizedPage";

function App() {
  const { isAuthenticated } = useAuthStore();
  useMaintenancePoll();
  return (
    <BrowserRouter>
      <MaintenanceBanner />
      <ForbiddenModal />
      <ReceiptPrintModal />
      <Routes>
        {/* Root redirect */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/mobile/accept-invitation" element={<AcceptMembershipInvitation />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        <Route
          element={
            <ProtectedRoute>
              <ProtectedLayout />
            </ProtectedRoute>
          }
        >
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requiredPermissions={["dashboard.view"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requiredPermissions={["users.view"]}>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/roles"
            element={
              <ProtectedRoute requiredPermissions={["roles.view"]}>
                <RoleManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/system-settings"
            element={
              <ProtectedRoute requiredPermissions={["system_settings.view"]}>
                <SystemSettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/audit-logs"
            element={
              <ProtectedRoute requiredPermissions={["audit_logs.view"]}>
                <AuditLogsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/drivers"
            element={
              <ProtectedRoute requiredPermissions={["drivers.view"]}>
                <DriversManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/transport-rates"
            element={
              <ProtectedRoute requiredPermissions={["transport_rates.view"]}>
                <TransportRatesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/vehicles"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.route_configure"]}>
                <VehiclesManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/route-templates"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.route_configure"]}>
                <RouteTemplatesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/trips"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.view"]}>
                <TripsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/plans"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.plans.view"]}>
                <DeliveryPlansPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/tray-pickups"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.view_outstanding_trays"]}>
                <TrayPickupsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <ProtectedRoute>
                <CustomerManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customers/:id"
            element={
              <ProtectedRoute>
                <CustomerDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/wallet-approvals"
            element={
              <ProtectedRoute requiredPermissions={["wallets.approve"]}>
                <WalletApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/points-approvals"
            element={
              <ProtectedRoute requiredPermissions={["loyalty.approve"]}>
                <PointsApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/loyalty-config"
            element={
              <ProtectedRoute requiredPermissions={["loyalty.config_view"]}>
                <PointsConfigListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/loyalty-config/approvals"
            element={
              <ProtectedRoute requiredPermissions={["loyalty.config_approve"]}>
                <PointsConfigApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-groups"
            element={
              <ProtectedRoute>
                <CustomersGroupManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/suppliers"
            element={
              <ProtectedRoute>
                <SupplierManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/inputs"
            element={
              <ProtectedRoute>
                <InputManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/batches/alerts"
            element={
              <ProtectedRoute>
                <BatcheAlertsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/stock-management"
            element={
              <ProtectedRoute>
                <StockManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/farms/greenhouses"
            element={
              <ProtectedRoute>
                <GreenhouseManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/input-types"
            element={
              <ProtectedRoute>
                <InputTypeManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/stock-recepit"
            element={
              <ProtectedRoute>
                <StockReceiptPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/requisition"
            element={
              <ProtectedRoute>
                <RequisitionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/requisitions"
            element={
              <ProtectedRoute>
                <RequisitionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/return-approvals"
            element={
              <ProtectedRoute requiredPermissions={["requisitions.approve_return"]}>
                <ReturnApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/my-returns"
            element={
              <ProtectedRoute requiredPermissions={["requisitions.return"]}>
                <MyReturnsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/store"
            element={
              <ProtectedRoute>
                <StoreInventoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/variety-pricing"
            element={
              <ProtectedRoute>
                <VarietyPricingManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/orders"
            element={
              <ProtectedRoute requiredPermissions={["orders.view"]}>
                <OrderManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/sales-review"
            element={
              <ProtectedRoute requiredPermissions={["orders.confirm_with_allocation", "orders.publish_ready_date"]}>
                <SalesReviewQueuePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/forecast-requests"
            element={
              <ProtectedRoute requiredPermissions={["forecast_requests.acknowledge"]}>
                <ForecastRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/field-oversight"
            element={
              <ProtectedRoute requiredPermissions={["field_oversight.view"]}>
                <FieldOversightPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/walk-in-sale"
            element={
              <ProtectedRoute requiredPermissions={["orders.walkin_sale"]}>
                <WalkInSalePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/crops"
            element={
              <ProtectedRoute>
                <CropsManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/crop-types"
            element={<Navigate to="/production/crops" replace />}
          />
          <Route
            path="/production/crop-varieties"
            element={<Navigate to="/production/crops" replace />}
          />
          <Route
            path="/production/manage-instructions"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.view"]}>
                <SowingManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/record-sowing"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.record_sowing"]}>
                <RecordSowingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/record-germination"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.record_germination"]}>
                <RecordGerminationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/record-dispatch"
            element={
              <ProtectedRoute requiredPermissions={["orders.dispatch"]}>
                <RecordDispatchPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/record-growth"
            element={
              <ProtectedRoute requiredPermissions={["production_activities.create"]}>
                <RecordGrowthPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/pending-acceptance"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.accept", "sowing_instructions.view"]}>
                <PendingAcceptancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/amendment-approvals"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.approve"]}>
                <AmendmentApprovalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/order-amendment-approvals"
            element={
              <ProtectedRoute requiredPermissions={["orders.amend_approve", "orders.amend_apply"]}>
                <OrderAmendmentApprovalPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/amendment-history"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.view"]}>
                <AmendmentHistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/order-amendment-history"
            element={
              <ProtectedRoute requiredPermissions={["orders.amend_view"]}>
                <OrderAmendmentHistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/payment-threshold-overrides"
            element={
              <ProtectedRoute requiredPermissions={["orders.view_payment_threshold_override"]}>
                <PaymentThresholdOverridesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/sowing-planner"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.view"]}>
                <SowingCalendarPlannerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/create-sowing-instruction"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.create"]}>
                <CreateSowingInstructionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/ready-for-growing"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.acknowledge", "sowing_instructions.view"]}>
                <ReadyForGrowingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/material-usage"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.record_material_usage"]}>
                <MaterialUsagePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/germination-chambers"
            element={
              <ProtectedRoute requiredPermissions={["germination_chambers.view"]}>
                <GerminationChambersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/greenhouse-stock"
            element={
              <ProtectedRoute requiredPermissions={["greenhouse_stock.view"]}>
                <GreenhouseStockEntriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/greenhouse-layout"
            element={
              <ProtectedRoute requiredPermissions={["greenhouse_stock.view"]}>
                <GreenhouseLayoutPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/greenhouse-stock-take"
            element={
              <ProtectedRoute requiredPermissions={["greenhouse_stock.view"]}>
                <GreenhouseStockTakePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/expos"
            element={<ProtectedRoute requiredPermissions={["expos.view"]}><ExposPage /></ProtectedRoute>}
          />
          <Route
            path="/expos/new"
            element={<ProtectedRoute requiredPermissions={["expos.create"]}><ExpoFormPage /></ProtectedRoute>}
          />
          <Route
            path="/expos/:id"
            element={<ProtectedRoute requiredPermissions={["expos.view"]}><ExpoDetailPage /></ProtectedRoute>}
          />
          <Route
            path="/expos/:id/edit"
            element={<ProtectedRoute requiredPermissions={["expos.update"]}><ExpoFormPage /></ProtectedRoute>}
          />
          <Route
            path="/expos/:id/transfers/new"
            element={<ProtectedRoute requiredPermissions={["expo_transfers.create"]}><ExpoTransferFormPage /></ProtectedRoute>}
          />
          <Route
            path="/expos/:expoId/transfers/:id"
            element={<ProtectedRoute requiredPermissions={["expo_transfers.view"]}><ExpoTransferDetailPage /></ProtectedRoute>}
          />
          <Route path="/expos/:id/sales/new" element={<ProtectedRoute requiredPermissions={["expo_sales.create"]}><ExpoSalePage /></ProtectedRoute>} />
          <Route
            path="/production/bulk-import-stock"
            element={
              <ProtectedRoute requiredPermissions={["sowing_instructions.import"]}>
                <BulkImportStockPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/reserved-orders"
            element={
              <ProtectedRoute requiredPermissions={["orders.view"]}>
                <ReservedOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/production/sowing-breakdown"
            element={
              <ProtectedRoute requiredPermissions={["reports.view"]}>
                <SowingBreakdownReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <ProtectedRoute>
                <PaymentsManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-methods"
            element={
              <ProtectedRoute requiredPermissions={["payment_methods.view"]}>
                <PaymentMethodsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoicing"
            element={
              <ProtectedRoute>
                <InvoicingManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/call-logs"
            element={
              <ProtectedRoute requiredPermissions={["call_center.access"]}>
                <Navigate to="/call-center?tab=calls" replace />
              </ProtectedRoute>
            }
          />
          <Route
            path="/call-center"
            element={
              <ProtectedRoute requiredPermissions={["call_center.access"]}>
                <CallCenterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/notification-center"
            element={
              <ProtectedRoute requiredPermissions={["notification_templates.view"]}>
                <NotificationCenterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/summary"
            element={
              <ProtectedRoute requiredPermissions={["sales.view_summary"]}>
                <SalesSummaryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/discount-approvals"
            element={
              <ProtectedRoute requiredPermissions={["discounts.view_approvals"]}>
                <DiscountApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/directors-reports"
            element={
              <ProtectedRoute requiredPermissions={["directors_reports.view"]}>
                <DirectorsReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoicing/ap/:id"
            element={
              <ProtectedRoute>
                <SupplierInvoiceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoicing/ar/:id"
            element={
              <ProtectedRoute>
                <SalesInvoiceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/overgrown-discard"
            element={
              <ProtectedRoute requiredPermissions={["discard_requests.create"]}>
                <OvergrownDiscardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/discard-approvals"
            element={
              <ProtectedRoute requiredPermissions={["discard_requests.approve"]}>
                <ProductionDiscardApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agroforestry/receive"
            element={
              <ProtectedRoute requiredPermissions={["agroforestry.create_receipt"]}>
                <AgroforestryReceiveStockPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agroforestry/approvals"
            element={
              <ProtectedRoute requiredPermissions={["agroforestry.approve_receipt"]}>
                <AgroforestryReceiptApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agroforestry/stock"
            element={
              <ProtectedRoute requiredPermissions={["agroforestry.view_stock"]}>
                <AgroforestryStockPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agroforestry/discard-approvals"
            element={
              <ProtectedRoute requiredPermissions={["discard_requests.approve"]}>
                <AgroforestryDiscardApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/reserve-release-approvals"
            element={
              <ProtectedRoute requiredPermissions={["greenhouse_stock.approve_reserve_release"]}>
                <ReserveReleaseApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route path="/production/greenhouse-transfers" element={<ProtectedRoute requiredPermissions={["greenhouse_transfers.view"]}><GreenhouseTransfersPage /></ProtectedRoute>} />
          <Route path="/production/greenhouse-transfers/:id" element={<ProtectedRoute requiredPermissions={["greenhouse_transfers.view"]}><GreenhouseTransferDetailPage /></ProtectedRoute>} />
          <Route
            path="/production/greenhouse-transfer-approvals"
            element={
              <ProtectedRoute requiredPermissions={["greenhouse_transfers.approve"]}>
                <GreenhouseTransferApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/discard-approvals"
            element={
              <ProtectedRoute requiredPermissions={["discard_requests.approve"]}>
                <InputDiscardApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/stock-receipt-approvals"
            element={
              <ProtectedRoute requiredPermissions={["inventory.approve_stock_receipt"]}>
                <StockReceiptApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/supplier-approvals"
            element={
              <ProtectedRoute requiredPermissions={["inventory.approve_supplier"]}>
                <SupplierApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-seed-approvals"
            element={<Navigate to="/production/customer-seed-approvals" replace />}
          />
          <Route
            path="/production/customer-seed-approvals"
            element={
              <ProtectedRoute requiredPermissions={["seed_batches.approve_quality"]}>
                <CustomerSeedApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoicing/void-requests"
            element={
              <ProtectedRoute>
                <VoidRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoicing/credit-notes"
            element={
              <ProtectedRoute>
                <CreditNotesPage />
              </ProtectedRoute>
            }
          />
          {/* Dispatch */}
          <Route
            path="/dispatch"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.view"]}>
                <DispatchManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/:id"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.view"]}>
                <DispatchDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/compensation-notes"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.approve_compensation"]}>
                <CompensationNotesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/reconciliation"
            element={
              <ProtectedRoute requiredPermissions={["dispatch.reconcile_pending_delivery"]}>
                <ReconciliationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/chart-of-accounts"
            element={
              <ProtectedRoute requiredPermissions={["accounts.view"]}>
                <ChartOfAccountsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/journal-entries"
            element={
              <ProtectedRoute requiredPermissions={["journal_entries.view"]}>
                <JournalEntriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/reports"
            element={
              <ProtectedRoute requiredPermissions={["financial_statements.view_trial_balance"]}>
                <FinancialReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/bank-accounts"
            element={
              <ProtectedRoute requiredPermissions={["bank_accounts.view"]}>
                <BankAccountsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/budgets"
            element={
              <ProtectedRoute requiredPermissions={["budgets.view"]}>
                <BudgetsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/cost-centres"
            element={
              <ProtectedRoute requiredPermissions={["cost_centres.view"]}>
                <CostCentresPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/company-profile"
            element={
              <ProtectedRoute requiredPermissions={["companies.view"]}>
                <CompaniesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/companies"
            element={
              <ProtectedRoute requiredPermissions={["companies.view"]}>
                <CompaniesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/financial-years"
            element={
              <ProtectedRoute requiredPermissions={["financial_years.view"]}>
                <FinancialYearsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/financial-years/compare"
            element={
              <ProtectedRoute requiredPermissions={["financial_years.view"]}>
                <FinancialYearComparePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/financial-years/:id"
            element={
              <ProtectedRoute requiredPermissions={["financial_years.view"]}>
                <FinancialYearDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/setup-approvals"
            element={
              <ProtectedRoute requiredPermissions={["crop_types.approve"]}>
                <SetupApprovalsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/production/my-submissions"
            element={
              <ProtectedRoute requiredPermissions={["crop_types.submit_for_approval"]}>
                <MySubmissionsPage />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
